import { Slot } from "../../models";
import { useAppDispatch } from "../../app/hooks";
import { closeBottomSheet } from "../../app/slice/mobileSlice";
import ChakraSlotSetupModal from "../SlotVariant/ChakraSlotSetupModal";

const MobileQuickSetup = ({ slot }: { slot: Slot | null }) => {
  const dispatch = useAppDispatch();

  if (!slot) return null;

  return (
    <ChakraSlotSetupModal
      isOpen
      slot={slot}
      onClose={() => dispatch(closeBottomSheet())}
    />
  );
};

export default MobileQuickSetup;
